const EVENTS = {
  ADDITIONAL_CONTENT_TIP: 'ADDITIONAL_CONTENT_TIP',
  NEW_USER_SECTION: 'NEW_USER_SECTION',
  SALES_AND_EXTRA_MODULE: 'SALES_AND_EXTRA_MODULE',
  SPARKLE_CAMPAIGN_READONLY: 'SPARKLE_CAMPAIGN_READONLY',
  SPARKLE_CAMPAIGN_SETTINGS: 'SPARKLE_CAMPAIGN_SETTINGS',
  SPARKLE_CAMPAIGN: 'SPARKLE_CAMPAIGN',
  STREAMING_CAMPAIGN: 'STREAMING_CAMPAIGN',
  STREAMING_SPARKLE_CAMPAIGN: 'STREAMING_SPARKLE_CAMPAIGN',
  PUBLISH_AND_NOTIFY_INFO: 'PUBLISH_AND_NOTIFY_INFO',
  CLUB_LIVE: 'CLUB_LIVE',
  ONBOARDING_LIVE: 'ONBOARDING_LIVE',
  DRM_SETTINGS: 'DRM_SETTINGS',
  ONLINE_EVENT_TOMORROW_NOTIFY: 'ONLINE_EVENT_TOMORROW_NOTIFY'
};

const CONFIG_EVENTS = [EVENTS.SPARKLE_CAMPAIGN_SETTINGS, EVENTS.DRM_SETTINGS];

export { EVENTS, CONFIG_EVENTS };
